import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Product } from '../../interface/interface';
import Breadcrumbs from '../Breadcrumbs';
import { useGuestCart } from '../../context/guestCartContext';
import GuestProductCards from './GuestProductCards';
import { frameProductObject } from '../../utils/framePrductObject';
import { generateSearchBreadcrumbs } from '../../utils/generateSearchBreadCrumbs';

const RenderGuestSearchedContent = () => {
  const location = useLocation();
  const { cartItems, addToCartMutation, removeProductFromCartMutation } =
    useGuestCart();
  const [products, setProducts] = useState<Array<Product>>([]);

  useEffect(() => {
    if (!location.state?.selectedProduct?.length) {
      setProducts([]);
      return;
    }
    setProducts(frameProductObject(location.state?.selectedProduct, cartItems));
  }, [location.state?.selectedProduct, cartItems]);

  return (
    <div>
      <Breadcrumbs
        data={[
          {
            tag: 'a',
            className: 'mr-3',
            href: '/guest/shop',
            children: <>Home</>,
          },
          ...generateSearchBreadcrumbs(location?.state),
        ]}
      />

      <div className="result-block-container">
        <ul className="grid grid-cols-1 gap-6 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4">
          {products.length ? (
            products?.map((product: Product) => (
              <div key={product.id}>
                <GuestProductCards
                  product={product}
                  addProductToCart={async () => {
                    await addToCartMutation.mutateAsync(product.product_code);
                  }}
                  removeProductFromCart={async () => {
                    await removeProductFromCartMutation.mutateAsync(
                      product.product_code,
                    );
                  }}
                  isAccessories={false}
                  allowedProduct={false}
                  isGuest={true}
                />
              </div>
            ))
          ) : (
            <p>There is no combination of products exists</p>
          )}
        </ul>
      </div>
    </div>
  );
};

export default RenderGuestSearchedContent;
